import React, { useContext } from 'react'
import { settingsContext } from '../../Context/settingsProvider'
import CancelIcon from '@mui/icons-material/CancelOutlined';
import { appContext } from '../../Context/appProvider';
import axios from 'axios';
import { baseUrl, path } from '../../constants';
import { api } from '../../api';

export default function LanguageChooser() {
    const {chooseLang, setChooseLang, setUserLang, languages, userLang, changeLang} = useContext(settingsContext)
    const {token} = useContext(appContext)

    // const updateUserLang = lang => {
    //     setUserLang(lang)
    //     setChooseLang(false)
    //     api(path.changeLanguage, {
    //         data: {lang}
    //     })
    // }

    return chooseLang && (
    <div className='inset-0 fixed bg-[#00000090] z-[999999] flex items-center justify-center'>
        <div className=' bg-white shadow-md rounded-md flex flex-col gap-2 p-4 relative'>
            <h4 className='text-black text-[16px] font-bold'>Choose Language</h4>
            <div className='grid grid-cols-4 max-md:grid-cols-2 p-3 gap-2 w-full'>
                {languages.map((language, i) => (
                    <button onClick={() => {
                        changeLang(language.value)
                    }} className='outline-none border-[transparent] bg-none text-[13px] text-black p-2 whitespace-nowrap border-[1px] hover:border-[#000000]' style={{
                        backgroundColor: userLang == language.value ? '#6622cf' : 'none',
                        color: userLang == language.value ? '#ffffff' : '#000000',
                    }} >{language.label}</button>
                ))}
            </div>
            <button className='outline-none border-none bg-none absolute top-3 right-3' onClick={() => setChooseLang(false)}>
                <CancelIcon>Filled</CancelIcon>
            </button>
        </div>
    </div>
    )
}
